// Rubriques soumises aux droits d'accès (code ↔ route)
export const SECTIONS = [
  { code: "dashboard", label: "Tableau de bord", path: "/" },
  { code: "clients", label: "Clients", path: "/clients" },
  { code: "planning", label: "Planning", path: "/planning" },
  { code: "agents", label: "Agents", path: "/agents" },
  { code: "candidates", label: "Candidats", path: "/candidats" },
  { code: "hours", label: "Heures", path: "/heures" },
  { code: "prepaie", label: "Prépaie", path: "/prepaie" },
  { code: "pointages", label: "Pointages GPS", path: "/pointages" },
  { code: "reports", label: "Rapports agents", path: "/rapports" },
  { code: "sites", label: "Sites", path: "/sites" },
  { code: "prestations", label: "Prestations", path: "/prestations" },
  { code: "devis", label: "Devis", path: "/devis" },
  { code: "factures", label: "Factures", path: "/factures" },
  { code: "documents", label: "Documents", path: "/documents" },
  { code: "doc_templates", label: "Modèles docs", path: "/modeles-documents" },
  { code: "agent_docs", label: "Docs à signer", path: "/documents-agents" },
  { code: "messages", label: "Messagerie", path: "/messages" },
  { code: "settings", label: "Paramètres", path: "/parametres" },
  { code: "materiel", label: "Matériel et équipements", path: "/materiel" },
];

export const canAccess = (user, code, mod) => {
  if (user?.is_superadmin || user?.is_staff) return !code;
  if ((mod || code) && user?.modules_off?.includes(mod || code)) return false;
  return !code || user?.role === "admin" || user?.permissions == null || user.permissions.includes(code);
};

export const firstAllowedPath = (user) => SECTIONS.find((s) => canAccess(user, s.code))?.path || null;
